import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';

export const EmailLearnMoreModal = ({ handleClose }) => {
  return (
    <MobileAwareOverlay onClose={handleClose} modalClass="preferences-modal">
      <div className="sui-grid sui-gap-4">
        <Typography variant="h2">How do I update my email preferences</Typography>
        <Typography variant="body-base">
          {`To make changes to your preferences,
            click on the individual preference options and press "Save Changes."`}
        </Typography>
        <Typography variant="h2">How do I unsubscribe from emails?</Typography>
        <Typography variant="body-base">
          To unsubscribe from future promotional emails from The Home Depot, unselect the email options.
          Please note, that on occasion you may receive transactional communications from The Home Depot.
        </Typography>
        <Typography variant="h2">Additional Promotional Email Details</Typography>
        <Typography variant="body-base">
          Please note that your consent to participate in the programs listed will be treated separately
          from your consent to participate in any of our other programs.
        </Typography>
      </div>
    </MobileAwareOverlay>
  );
};

EmailLearnMoreModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
